export default {
  namespaced: true,
  state: {
    list: [],
  },
  actions: {
    GetList({ commit, rootGetters, dispatch }) {
      commit('setField', { name: 'list', value: [] });
      return new Promise((resolve, reject) => {
        rootGetters.ax.post('feedback/api/feedback/faq')
          .then((response) => {
            if (response && response.data) {
              commit('setField', { name: 'list', value: response.data.faq.filter(item => item.is_published) });
              resolve(response.data);
            }
            reject(new Error('no response data'));
          })
          .catch((error) => {
            dispatch('HandleError', error, { root: true });
            reject(error);
          });
      });
    },
    InitialStoreFaq({ commit }) {
      commit('setField', { name: 'list', value: [] });
    },
  },
  mutations: {
    setField(state, payload) {
      state[payload.name] = payload.value;
    },
  },
};
